import { Component, OnInit, OnDestroy } from '@angular/core';

/**
 * service imports
 */
import { GetService } from '../../dataservices/get.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
import { DqVideoPlayerService } from '../../dataservices/dqVideoPlayer/dq-video-player.service';
import { DataStorageService } from '../../dataservices/data-storage.service';

/**
 * constant imports
 */
import { HCF_CONNECTION_ID, PRODUCT_TYPE_CONSTANT, NUMBERS, SCREEN_NAME } from '../../constants/app.constants';

/**
 * interface imports
 */
import { ContinueWatchList } from '../../onboarding/interface/global.model';
import { EventDataKey } from '../../analytics-event/analytics.model';
/**
 * rxjs imports
 */
import { Subject, Subscription } from 'rxjs';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
@Component({
  selector: 'app-view-all-doc-web',
  templateUrl: './view-all-doc-web.component.html',
  styleUrls: ['./view-all-doc-web.component.scss']
})
export class ViewAllDocWebComponent implements OnInit, OnDestroy {


  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * detail data
   */
  public list: ContinueWatchList[] = [];

  /**
   * to store title
   */
  public title: string;

  /**
   * start time for the page visited
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public startTime: any;

  /**
   * offset
   */
  public offset = 1;

  /**
   * @notifier$ defines a notifier subject stream to end data streaming
   */
  private notifier$ = new Subject();

  constructor(
    public getApiService: GetService,
    public fcs: FunCollectionService,
    public analyticsEventService: AnalyticsEventService,
    public dqVideoPlayerService: DqVideoPlayerService,
    private dss: DataStorageService
  ) { }

  /**
   * Send analytics event.
   */
  sendAnalytics(eventName: EventDataKey, productType: number, productTypeId: number, screenName: string, startTime = this.startTime, endTime = this.getTimeString()): void {
    const analyticsData = {
      event_name: eventName,
      product_type: productType,
      product_type_id: productTypeId,
      screen_name: screenName,
      start_time: startTime,
      end_time: endTime
    };
    this.analyticsEventService.logAnalyticsEvent(analyticsData);
  }
  /**
   * get view all data
   */
  public getViewAllDetails(): void {
    if (this.offset != 0) {
      this.subscriptions.add(this.getApiService.getContinueWatchData(HCF_CONNECTION_ID.CONTINUE_WATCH, this.offset).subscribe(res => {
        if (res !== null) {
          this.list = this.list.concat(res.data[0].list);
          this.title = res.data[0].title;
          this.offset = res.data[0].offset;
        }
      }));
    }
  }
  /**
   * on scroll function
   */
  public onScroll(): void {
    if (this.offset > 0) {
      this.getViewAllDetails();
    }
  }
  /**
   * gets play time in minute
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hcfPlayTime(playTime: any): string {
    return (playTime !== 0 ? this.fcs.secondToHoursMinutesSeconds(playTime) : '');
  }
  /**
   * video card redirection
   */
  public cardTarget(event, cardInfo): void {
    if (cardInfo.product_type === PRODUCT_TYPE_CONSTANT.WEBINAR) {
      this.dqVideoPlayerService.webinarContinueWatchResumeTime = cardInfo?.info?.time?.watch;
    }
    this.fcs.validateTargetType(event, +cardInfo.product_id);
  }

  /**
   * Get the current time in string.
   */
  getTimeString(): string {
    return new Date().getTime().toString();
  }
  ngOnInit(): void {
    this.startTime = this.getTimeString();
    this.getViewAllDetails(); 
  }

  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
    this.sendAnalytics(EVENT_NAME.CONTINUE_WATCH_VIEWALL_VISIT, NUMBERS.ZERO, NUMBERS.ZERO, SCREEN_NAME.CONTINUE_WATCH_VIEWALL);
  }
}
